var map = {
	"./android-chrome-192x192": 13,
	"./android-chrome-192x192.png": 13,
	"./android-chrome-512x512": 14,
	"./android-chrome-512x512.png": 14,
	"./apple-touch-icon": 15,
	"./apple-touch-icon.png": 15,
	"./favicon-16x16": 16,
	"./favicon-16x16.png": 16,
	"./favicon-32x32": 17,
	"./favicon-32x32.png": 17,
	"./favicon.ico": 76,
	"./mstile-144x144": 18,
	"./mstile-144x144.png": 18,
	"./mstile-150x150": 19,
	"./mstile-150x150.png": 19,
	"./mstile-310x310": 20,
	"./mstile-310x310.png": 20,
	"./mstile-70x70": 21,
	"./mstile-70x70.png": 21,
	"./safari-pinned-tab": 22,
	"./safari-pinned-tab.svg": 22
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;